export default __webpack_public_path__ + "static/media/Modular.1ee99f0e.svg";